import BeSafeButton from "components/commons/BeSafeButton";
import BeSafeTableCard from "components/commons/BeSafeTableCard";
import BeSafeTable from "components/commons/table/BeSafeTable";
import { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import _ from "lodash";

const BeSafeMultiSelectTableModal = (props) => {
  const initialSelected = props.initialSelected;
  const [selectedItems, setSelectedItems] = useState(initialSelected);
  const [allSelectedItems, setAllSelectedItems] = useState(false);
  const [totalSelectedItems, setTotalSelectedItems] = useState(initialSelected.length);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const initialItems = props.items;

  const handleSubmit = () => {
    if (_.isFunction(props.onChange)) {
      props.onChange(selectedItems);
      onHide();
    }
  };

  const onHide = () => {
    setSelectedItems([]);
    props.onHide();
    setSearchQuery("");
    setAllSelectedItems(false);
  };

  useEffect(() => {
    setLoading(true);

    if (searchQuery === "") {
      setItems(initialItems);
      setLoading(false);
      return;
    }

    const filteredItems = [];

    initialItems.forEach(group => {
      if (hasChildren(group)) {
        filteredItems.push({
          name: group.name,
          displayName: group.displayName,
          children: group.children.filter(item =>
            item.displayName.toLowerCase().startsWith(searchQuery.toLowerCase()) ||
            item.displayName.toLowerCase().includes(searchQuery.toLowerCase())
          )
        });
        return;
      }

      if (group.displayName.toLowerCase().startsWith(searchQuery.toLowerCase()) ||
        group.displayName.toLowerCase().includes(searchQuery.toLowerCase())) {
        filteredItems.push(group);
      }
    });

    setItems(filteredItems);

    setLoading(false);
  }, [searchQuery, initialItems]);

  const isSelected = (item) => {
    return selectedItems.findIndex(name => name === item.name) > -1;
  };

  const selectItem = (item) => {
    let newItems = [];
    if (selectedItems.includes(item.name)) {
      newItems = _.without(selectedItems, item.name);
      setSelectedItems(newItems);
      setTotalSelectedItems(newItems.length);
    } else {
      if (props.limit === 0 || selectedItems.length < props.limit) {
        newItems = [...selectedItems, item.name];
        setSelectedItems(newItems);
        setTotalSelectedItems(newItems.length);
      }
    }
  };

  const handleAllSelectedItems = () => {
    let newSelectedItems;
    let selectedItemsValue = !allSelectedItems;
    if (selectedItemsValue) {
      const unselectedItems = items.map(item => item.name).filter(item => !selectedItems.includes(item));
      newSelectedItems = [...unselectedItems, ...selectedItems];
    } else {
      newSelectedItems = initialSelected;
    }
    setSelectedItems(newSelectedItems);
    setTotalSelectedItems(newSelectedItems.length);
    setAllSelectedItems(selectedItemsValue);
  };

  const hasChildren = (item) => {
    return item.children && item.children.length > 0;
  }

  const onSearch = (query) => {
    setSearchQuery(query);
  };

  const defaultColumns = [
      {
        header: <Form.Check
                  type="checkbox"
                  className="mb-0 d-inline-block align-middle"
                  value={allSelectedItems}
                  checked={allSelectedItems}
                  onChange={handleAllSelectedItems}
                />,
        cellRenderer: (item) => <Form.Check
                                  type="checkbox"
                                  className="mb-0 d-inline-block align-middle"
                                  value={isSelected(item)}
                                  checked={isSelected(item)}
                                  disabled={initialSelected.includes(item.name)}
                                  onChange={() => selectItem(item)}
                                />
      }
  ];

  const columns = () => {
    return [...defaultColumns, ...props.columns];
  }

  const modalHeader = () => {
    if(props.modalTitle) {
      return <Modal.Title>{props.modalTitle}</Modal.Title>;
    }
    return null;
  };

  return (
    <>
      <Modal
        show={props.showModal}
        onEnter={() => {
          setSelectedItems(initialSelected);
          setItems(props.items);
        }}
        onHide={onHide}
      >
        <Modal.Header closeButton>
          {modalHeader()}
        </Modal.Header>
        <Modal.Body>
          <BeSafeTableCard
            itemCount={totalSelectedItems}
            onSearch={onSearch}
            withSearch
            footerMessage={<FormattedMessage id="GENERAL.TOTAL_SELECTED"/>}
          >
            <div className="overflow-auto simple-scroll scroll-table">
              <BeSafeTable
                loading={loading}
                rows={items}
              >
                {
                  columns().map(column => (
                      <BeSafeTable.Column
                        header={column.header}
                        cellRenderer={column.cellRenderer}
                      />
                    )
                  )
                }
              </BeSafeTable>
            </div>
          </BeSafeTableCard>
        </Modal.Body>
        <Modal.Footer>
          <BeSafeButton
            text={<FormattedMessage id="GENERAL.SAVE" />}
            onClick={handleSubmit}
          />
        </Modal.Footer>
      </Modal>
    </>
  )
};

export default BeSafeMultiSelectTableModal;
